import React ,{useState} from 'react'
import './Stars.css'

const Stars = ({canMod,Rates,onClick}) => {

    const Stars=Array.from({length:5})

    const[StarState,setStarState]=useState(0)
    

    function Reviewed(e) {
        //setstarsSelected()
        //alert(e.currentTarget.getAttribute("index"))
       // let index=e.currentTarget.getAttribute("index")
       // Stars.fill(true,0,index)
        //setStarState(index)

        //alert(Stars)

    }

  return (
    <div id='Stars' className={canMod?"Mod":""}>
        {   
            Stars.map((_,index)=>{ 
                const isFull=index<Rates
                
                return (
            <div key={index} className='star' index={index+1} onClick={e=>onClick(e)}>
                <svg version="1.1" id="Layer_1" 
                    viewBox="0 0 501.28 501.28" className={isFull?"Full":"Empty"}>
                <g>
                    <polygon id="secondHalf"  points="501.28,194.37 335.26,159.33 250.64,12.27 250.64,419.77 405.54,489.01 387.56,320.29"/>
                    <polygon id="firstHalf"  points="166.02,159.33 0,194.37 113.72,320.29 95.74,489.01 250.64,419.77 250.64,12.27"/>
                </g>
                </svg>
            </div>)
            })
        }
    </div>
  )
}

export default Stars